const ROUTES = {
    DETAILS: 'DETAILS',
    LIVE_MATCHES: 'LIVE_MATCHES',
    TOURNAMENTS: 'TOURNAMENTS'
}

export { ROUTES }